export const TAG=false;
export const COMMIT='473ec2799ac10fcf016f24accb339742b0140a7a';
export const BRANCH='prod';
